import { inject, Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { FeatureState } from '../../types/enum/feature-state';

@Injectable({
  providedIn: 'root',
})
export class FeatureService {
  private configService = inject(ConfigService);

  isPassportFlowEnabled(): boolean {
    return this.configService.config.features?.passportFlow === FeatureState.enabled;
  }
}
